import { render } from "./Pos.vue?vue&type=template&id=324709ba&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"

import "./Pos.vue?vue&type=style&index=0&id=324709ba&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LEADA/mi-stock-leada-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324709ba"]])

export default __exports__